import { createSlice } from "@reduxjs/toolkit";

// ------------------------------------------ Constantes

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

// 0 = Janvier 1 = Février 2 = Mars 3 = Avril 4 = Mai 5 = Juin 6 = Juillet 7 = Août 8 = Septembre 9 = Octobre 10 = Novembre 11 = Décembre
const arrMonthsx2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] // 2 years
const arrWeeksx2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52] // 2 years
const arr31 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31] // Janvier, Mars, Mai, Juillet, Aout, Octobre, Décembre
const arr30 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] // Avril, Juin, Septembre, Novembre
const arr29 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29] // Février
const arr28 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28] // Février




// ------------------------------------------ Slice

// createSlice permet de fusionner action et reducer (modifi store)
export const recordsSlice = createSlice({
  name: "recordings",
  initialState: {
    records: [],
    last10RecordsArray: [],
    exportedArray: [],
    pendingArray: [],
    failedArray: [],
    newArray: [],
    sizeArrays: {},
    exportedSeriesByMonthsArray: [],
    exportedSeriesByWeeksArray: [],
    exportedSeriesByDaysArray: [],
    percentMonths: null,
    percentWeeks: null,
    percentDays: null,
    sse: null
  },
  reducers: {
    setSSEForREC: (state, { payload }) => {
      state.sse = payload;
    },
    setRecordsData: (state, { payload }) => { //? payload = data qu'on recupère en paramètre
      // set all records
      const allRecordsArraySorted = sortArrayByRecordingDate(payload);
      state.records = payload.length > 0 ? allRecordsArraySorted : [];

      if (payload.length > 0) {
        // set last 10 recs array for Timeline
        const last10RecsArray = getLast10Records(allRecordsArraySorted);
        state.last10RecordsArray = last10RecsArray;

        // set all records in array by states
        let exportedArray = [];
        let pendingArray = [];
        let failedArray = [];
        let newArray = [];
        for (let i = 0; i < payload.length; i++) {
          payload[i].state === "exported" ? exportedArray.push(payload[i]) :
          payload[i].state === "pending" ? pendingArray.push(payload[i]) :
          payload[i].state === "new" ? newArray.push(payload[i]) :
          failedArray.push(payload[i])
        }
        state.exportedArray = exportedArray;
        state.pendingArray = pendingArray;
        state.failedArray = failedArray;
        state.newArray = newArray;

        // set la taille des arrays en units or not
        let exportedArrSize = getArraySize(exportedArray);
        let newArrSize = getArraySize(newArray);
        let failedArrSize = getArraySize(failedArray);
        let sizeArrs = {
          exported: {
            withUnit: exportedArrSize.withUnit,
            withoutUnit: exportedArrSize.withoutUnit
          },
          new: {
            withUnit: newArrSize.withUnit,
            withoutUnit: newArrSize.withoutUnit
          },
          failed: {
            withUnit: failedArrSize.withUnit,
            withoutUnit: failedArrSize.withoutUnit
          },
          totalData: niceBytes(exportedArrSize.withoutUnit + newArrSize.withoutUnit + failedArrSize.withoutUnit, 1)
        }
        state.sizeArrays = sizeArrs;

        // setSeries
        state.exportedSeriesByMonthsArray = setSerries(state.exportedArray, 'month');
        state.exportedSeriesByWeeksArray = setSerries(state.exportedArray, 'week');
        state.exportedSeriesByDaysArray = setSerries(state.exportedArray, 'day');

        // setPercent
        state.percentMonths = setEvoPercent(state.exportedSeriesByMonthsArray);
        state.percentWeeks = setEvoPercent(state.exportedSeriesByWeeksArray);
        state.percentDays = setEvoPercent(state.exportedSeriesByDaysArray);
      }
    },
    addNew: (state, { payload }) => {
        state.records.push(payload);
    },
  },
});





// ------------------------------------------ Functions

// Sort an array by export date if exist or recording date
function sortArrayByRecordingDate (array) {
  let sortedArray = [...array];
  sortedArray.sort((x, y) => {
    let firstDate = x.exportDate ? new Date(x.exportDate) : new Date(x.date);
    let SecondDate = y.exportDate ? new Date(y.exportDate) : new Date(y.date);
    if (firstDate < SecondDate) return -1;
    if (firstDate > SecondDate) return 1;
    return 0;
  });
  return sortedArray;
}

// Get the last 10 recordings
function getLast10Records (newRecData) {
  let arr1 = [];
  let arr2 = [];
  let value = newRecData.length > 10 ? 10 : newRecData.length;
  for (let i = 0; i < value; i++) { arr1.push(i+1) };
  
  arr1.map((i) => (
    arr2.push(
      {
        id: newRecData[newRecData.length-i]._id,
        title: newRecData[newRecData.length-i].fileName,
        name: newRecData[newRecData.length-i].recordedParty.name,
        state: newRecData[newRecData.length-i].state,
        recordDate: newRecData[newRecData.length-i].date,
        exportDate: newRecData[newRecData.length-i].exportDate,
        destination: newRecData[newRecData.length-i].destination,
        exportMethod: newRecData[newRecData.length-i].exportMethod
      }
    )
  ))
  return arr2;
}

// function formatBytes(bytes, decimals = 2, step = 0) {
//   if (!+bytes) return '0 Bytes'

//   const k = 1024
//   const dm = decimals < 0 ? 0 : decimals
//   const i = Math.floor(Math.log(bytes) / Math.log(k))

//   // return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${units[i]}`
//   if (step === 0) {
//     return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))}`
//   } else {
//     return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${units[i]}`
//   }
// }

// Calcul size of recordings
function niceBytes(x, step){
  let l = 0, n = parseInt(x, 10) || 0;
  while(n >= 1024 && ++l){
      n = n/1024;
  }

  if (step === 0) {
    return(n.toFixed(n < 10 && l > 0 ? 1 : 0));
  } else {
    return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
  }
}

// Set Array's size of recordings
function getArraySize (array) {
  let newArray = [...array];
  let sizeArray = [];
  for (let i = 0; i < newArray.length; i++) {
    sizeArray.push(newArray[i].size)
  }

  let sum = 0;
  for (let i = 0; i < sizeArray.length; i++) {
      sum += sizeArray[i];
  }
  let obj = {
    withoutUnit: sum,
    withUnit: niceBytes(sum, 1)
  }
  return obj;
}

// Retourne le nombre de jour en Février selon l'année indiquée
function fevrierbissextile(annee) {
  if ((annee % 100 != 0 && annee % 4 == 0) || (annee % 400 == 0)) {
      return 29;
  } else {
      return 28;
  }
} 

// Retourne la numéro de la semaine courante
function getWeekNumber(d) {
  var DoW = d.getDay();
  d.setDate(d.getDate() - (DoW + 6) % 7 + 3); // Nearest Thu
  var ms = d.valueOf(); // GMT
  d.setMonth(0);
  d.setDate(4);
  return Math.round((ms - d.valueOf()) / (7 * 864e5)) + 1;
}

// Calculs du nombre des derniers records pour déterminer les 7 dernières series => days / weeks / months
function setSerries(exportedArray, period) {
  const now = new Date();
  let actualNow = new Date();
  let nowWeek = getWeekNumber(actualNow);
  let pastWeek = nowWeek === 1 ? 52 : nowWeek-1;
  let nowYear = now.getFullYear();
  let pastYear = nowYear-1;
  let nowDay = now.getDate();
  
  let thisMonth = now.getMonth();
  let fevrierNbrJour = fevrierbissextile(nowYear); // Check le nombre de jour en Février selon l'année actuelle
  let arrFev = fevrierNbrJour === 29 ? arr29 : arr28; 
  
  let arrNowMonth;
  let arrPastMonth;
  let daysArrayLast2Months;
  let weeksArrayLast2Years;
  let monthsArrayLast2Years;

  // let periodBetweenDates = 0;
  let period0 = 0;
  let period1 = 0;
  let period2 = 0;
  let period3 = 0;
  let period4 = 0;
  let period5 = 0;
  let period6 = 0;
  

  // 1 -----------------------------------------------------------------------------------------
  // Construction des arrays daysArrayLast2Months / weeksArrayLast2Years / monthsArrayLast2Years

  // Determine un array comprenant les jours de ce mois et du precedent (en prenant en compte le mois de Février et les années bisextiles)
  if (period === "day") {
    // Determine le nombre de jour par array
    if (thisMonth === 1) arrNowMonth = arrFev;
      else if (thisMonth === 0 || 2 || 4 || 6 || 7 || 9 || 11) arrNowMonth = arr31;
      else arrNowMonth = arr30;
    if (thisMonth === 2) arrPastMonth = arrFev;
      else if (thisMonth === 0 || 2 || 4 || 6 || 7 || 9 || 11) arrPastMonth = arr31;
      else arrPastMonth = arr30;
  
    // Montage de l'array avec ce mois et le precedent
    daysArrayLast2Months = arrPastMonth.concat(arrNowMonth);
    
    // Je modifie l'array daysArrayLast2Months pour qu'il termine par le jour actuel
    for (let i = 0; i < daysArrayLast2Months.length; i++) {
      if (daysArrayLast2Months[daysArrayLast2Months.length-1] !== nowDay) {
        daysArrayLast2Months.pop();
      }
    }
  }

  // Determine un array comprenant les semaines de cette année et de la precedente
  if (period === "week") {
    weeksArrayLast2Years = arrWeeksx2;
    // Je modifie l'array arrWeeksx2 pour qu'il termine par la semaine actuelle
    for (let i = 0; i < weeksArrayLast2Years.length; i++) {
      if (weeksArrayLast2Years[weeksArrayLast2Years.length-1] !== nowWeek) {
        weeksArrayLast2Years.pop();
      }
    }
  }

  // Determine un array comprenant les mois de cette année et de la precedente
  if (period === "month") {
    monthsArrayLast2Years = arrMonthsx2;
    // Je modifie l'array arrWeeksx2 pour qu'il termine par la semaine actuelle
    for (let i = 0; i < monthsArrayLast2Years.length; i++) {
      if (monthsArrayLast2Years[monthsArrayLast2Years.length-1] !== thisMonth) {
        monthsArrayLast2Years.pop();
      }
    }
  }


  // 2 --------------------------------------------------------------------------
  // Boucle sur tous les records pour incrementer les periods (day, week & month)

  for (let i = 0; i < exportedArray.length; i++) {
    let exportDate = new Date(exportedArray[i].exportDate);

    // -------------------------
    // DEBUT DU TRAITEMENT DAILY
    if (period === "day") {
      let actualExportDate = new Date(exportedArray[i].exportDate);
      let exportDateDay = exportDate.getDate();
      let exportDateWeek = getWeekNumber(actualExportDate);
      let exportDateYear = exportDate.getFullYear();

      // Check si l'exportDate correspond à cette année ou à la precedente (same pour la semaine)
      if ((exportDateYear === nowYear || exportDateYear === pastYear) && (exportDateWeek === nowWeek || exportDateWeek === pastWeek)) {
        // Determine les séries DAILY
          // Si l'exportDate correspond à ce jour ou aux 6 precedents, j'incremente l'array correspondant
          // (si exportDateDay = au dernier element de daysArrayLast2Months)
        if (exportDateDay === daysArrayLast2Months[daysArrayLast2Months.length-1]) period0 = period0 + 1;
        else if (exportDateDay === daysArrayLast2Months[daysArrayLast2Months.length-2]) period1 = period1 + 1;
        else if (exportDateDay === daysArrayLast2Months[daysArrayLast2Months.length-3]) period2 = period2 + 1;
        else if (exportDateDay === daysArrayLast2Months[daysArrayLast2Months.length-4]) period3 = period3 + 1;
        else if (exportDateDay === daysArrayLast2Months[daysArrayLast2Months.length-5]) period4 = period4 + 1;
        else if (exportDateDay === daysArrayLast2Months[daysArrayLast2Months.length-6]) period5 = period5 + 1;
        else if (exportDateDay === daysArrayLast2Months[daysArrayLast2Months.length-7]) period6 = period6 + 1;
      } 
    } // FIN DU TRAITEMENT DAILY


    // --------------------------
    // DEBUT DU TRAITEMENT WEEKLY
    if (period === "week") {
      let actualExportDate = new Date(exportedArray[i].exportDate);
      let exportDateWeek = getWeekNumber(actualExportDate);
      let exportDateYear = exportDate.getFullYear();

      // Check si l'exportDate correspond à cette année ou à la precedente
      if (exportDateYear === nowYear || exportDateYear === pastYear) {
        // Determine les séries WEEKLY
          // Si l'exportDateWeek correspond à cette semaine ou aux 6 precedentes, j'incremente l'array correspondant
        if (exportDateWeek === weeksArrayLast2Years[weeksArrayLast2Years.length-1]) period0 = period0 + 1;
        else if (exportDateWeek === weeksArrayLast2Years[weeksArrayLast2Years.length-2]) period1 = period1 + 1;
        else if (exportDateWeek === weeksArrayLast2Years[weeksArrayLast2Years.length-3]) period2 = period2 + 1;
        else if (exportDateWeek === weeksArrayLast2Years[weeksArrayLast2Years.length-4]) period3 = period3 + 1;
        else if (exportDateWeek === weeksArrayLast2Years[weeksArrayLast2Years.length-5]) period4 = period4 + 1;
        else if (exportDateWeek === weeksArrayLast2Years[weeksArrayLast2Years.length-6]) period5 = period5 + 1;
        else if (exportDateWeek === weeksArrayLast2Years[weeksArrayLast2Years.length-7]) period6 = period6 + 1;
      }
    } // FIN DU TRAITEMENT WEEKLY


    // ---------------------------
    // DEBUT DU TRAITEMENT MONTHLY
    if (period === "month") {
      let actualExportDate = new Date(exportedArray[i].exportDate);
      let exportDateMonth = exportDate.getMonth();
      let exportDateYear = now.getFullYear();
      
      // Check si l'exportDate correspond à cette année ou à la precedente
      if (exportDateYear === nowYear || exportDateYear === pastYear) {
        // Determine les séries MONTHLY
          // Si l'exportDateMonth correspond à ce mois ou aux 6 precedents, j'incremente l'array correspondant
        if (exportDateMonth === monthsArrayLast2Years[monthsArrayLast2Years.length-1]) period0 = period0 + 1;
        else if (exportDateMonth === monthsArrayLast2Years[monthsArrayLast2Years.length-2]) period1 = period1 + 1;
        else if (exportDateMonth === monthsArrayLast2Years[monthsArrayLast2Years.length-3]) period2 = period2 + 1;
        else if (exportDateMonth === monthsArrayLast2Years[monthsArrayLast2Years.length-4]) period3 = period3 + 1;
        else if (exportDateMonth === monthsArrayLast2Years[monthsArrayLast2Years.length-5]) period4 = period4 + 1;
        else if (exportDateMonth === monthsArrayLast2Years[monthsArrayLast2Years.length-6]) period5 = period5 + 1;
        else if (exportDateMonth === monthsArrayLast2Years[monthsArrayLast2Years.length-7]) period6 = period6 + 1;
      }
    } // FIN DU TRAITEMENT MONTHLY

  } //? FIN DE L'INCREMENTATION DES PERIODS


  // 3 --------------------------------------------------------------------------
  // Retourne les series DAILY / WEEKLY / MONTHLY

  let last7PeriodSeries = [period6, period5, period4, period3, period2, period1, period0];
  return last7PeriodSeries;
}



// Calcul de pourcentage d'évoltion
function numVariation(a, b) {
  return ((b / a) - 1) * 100;
}

// Calcul des pourcentages d'evolution des records (day, week & month)
function setEvoPercent(exportedPeriodsArray) {
  const last1 = exportedPeriodsArray[exportedPeriodsArray.length-1] || 0;
  const last2 = exportedPeriodsArray[exportedPeriodsArray.length-2] || 0;
  let periodPercent;
  if (last1 === last2) {
    periodPercent = 0;
  } else {
    periodPercent = numVariation(last2, last1) != Infinity  
    ? last1 == 0 
      ? -100 
      : numVariation(last2, last1) && (last1 != last2) 
      ? numVariation(last2, last1) 
      : 0  
    : 100;
  }
  return periodPercent;
}


// jarrive pas a avoir le bon % sous 100% si last1 > last2



// ------------------------------------------ Export

// On a l'action et le reducer au mm endroit
export const { setRecordsData, setSSEForREC, addNew } = recordsSlice.actions;
export default recordsSlice.reducer;
